import styled, { StyledComponent } from '@emotion/styled';
import { Theme, Spinner } from '@prometheus/components';

export const LayoutContainer: StyledComponent<any> = styled.div<any>`
  min-height: 100vh;
  width: 100vw;
  max-width: 100%;
  background-color: #ffffff;
  //${({ theme }) => theme.palette.backgroundColor.dark};
`;

export const ContentContainer: StyledComponent<any> = styled.div`
  padding-left: 70px;
`;

export const NavigationSubContainer = styled.div<any>`
  display: flex;
  height: 60px;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  background-color: ${({ theme }: any) => theme.palette.backgroundColor.header};
  position: relative;
  font-size: 14px;
  box-shadow: ${({ theme }: any) => theme.shadows[1]};
  z-index: 4;
  * {
    color: #ffffff;
  }
`;

export const UserActionsContainer = styled.div<any>`
  display: flex;
  height: 50px;
  align-items: center;
  box-sizing: border-box;
  z-index: 1;
`;

export const EntityContainer = styled.div`
  height: 100%;
`;

export const PageContainer = styled.div`
  position: relative;
  min-height: calc(100vh - 60px);
  margin-right: var(--prometheus-ai-chat-width, 0px);
  transition: margin-right 180ms ease;

  @media (max-width: 900px) {
    margin-right: 0;
  }
`;

export const LayoutSpinner = styled(Spinner)`
  margin-top: 20%;
`;
